import React from "react";
import { useFetch } from "../../../helpers/hooks.jsx";
import { formatDate } from "../../../helpers/helpers";
import jsonData from "./Post02.json";

const BlogPost = ({ lang }) => {
  const [bank, loadingBank] = useFetch("/bank.json");

  return (
    <div className="postContainer post-container-center">
      <div className="postHeader">
        <h1 className="postTitle">{jsonData.title[lang]}</h1>
        <span className="postedBy">{formatDate(lang, "2017-05-15")}</span>
      </div>
      <div className="postText postText-center">
        <div className="postImageContainer-70">
          <img src="images/A5letakCD_01.jpg" alt="flyer01" />
        </div>
        <p className="postText">{jsonData.buy[lang]}</p>
        <p className="postText postText-small">{jsonData.founded[lang]}</p>
        <p className="postText postText-small">
          {jsonData.order[lang]}
          <br />
          <b>sancta-cecilia@seznam.cz, j.j.cerveny@isp24.cz</b>
        </p>
        <p
          className="postText postText-small"
          dangerouslySetInnerHTML={{
            __html: jsonData.bord[lang] + "<br/>" + jsonData.names[lang],
          }}
        ></p>
        <p
          className="postText"
          dangerouslySetInnerHTML={{
            __html: loadingBank ? "" : bank[lang],
          }}
        ></p>
        <p className="postText postText-small">
          e-mail: sancta-cecilia@seznam.cz
        </p>
      </div>
    </div>
  );
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/Home/post02/Post02.jsx